import { setBookingApplicationMod, useOrderInfo } from 'entities/orders';
import { Flex } from 'shared/ui/flex';
import { Typography } from 'shared/ui/typography';
import { TypographyContainer } from './styles';
import { FC } from 'react';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { useModal } from 'shared/lib/modal';
import { useAppDispatch } from 'shared/lib/store';

interface OrderPlaceHolderProps {
	placeholder: string;
	newApplicationBtn?: boolean;
}

export const OrderPlaceHolder: FC<OrderPlaceHolderProps> = ({
	placeholder,
	newApplicationBtn = false
}) => {
	const { isOpen } = useOrderInfo();
	const {openModal} = useModal();
	const dispatch = useAppDispatch();

	const startNewApplication = async () => {
		await dispatch(setBookingApplicationMod({isWork: true}));
		openModal();
	}

	return (
		<>
			{!isOpen && (
				<Flex $direction='column' $height='100%'>
					{newApplicationBtn && (
						<ButtonContained onClick={startNewApplication}>Новая заявка</ButtonContained>
					)}
					<Flex $justify="center" $alignItems="center" $margin='auto auto'>
						<TypographyContainer>
							<Typography colorVariant={'main'}>
								{placeholder}
							</Typography>
						</TypographyContainer>
					</Flex>
				</Flex>
			)}
		</>
	);
};
